/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingEventHistoryStateEnum = 'RECEIVED' | 'PROCESSED';

export const BillingEventHistoryStateEnum = {

    RECEIVED: 'RECEIVED' as BillingEventHistoryStateEnum,

    PROCESSED: 'PROCESSED' as BillingEventHistoryStateEnum
};

